import { sum } from 'lodash'
import { energyTypeToEerCoefficientMap } from '../../eer-coefficients/eer-coefficients'
import { PurchasedEnergyType } from '../../generated/graphql'

type EnergyResult = {
  energyType: PurchasedEnergyType
  total: number
}

/**
 * Loosely following section 2.4 in
 * "Energiatodistusopas 2018: Rakennuksen energiatodistus ja E-luvun määrittäminen, 1.11.2018"
 * published by Ympäristöministeriö,
 * the EER (E-luku) is calculated from the weighted energy usage (in kWh) divided by the area of the building.
 */
export function calculateEer(
  totalEnergies: EnergyResult[],
  area: number,
): number {
  const weightedKwhs = totalEnergies.map((energyType) => {
    const kwhUsed = energyType.total / 1000
    const weight = energyTypeToEerCoefficientMap[energyType.energyType]
    return kwhUsed * weight
  })

  return sum(weightedKwhs) / area
}
